// extracted by mini-css-extract-plugin
export default {"container":"RectanglesChart_container__irsS3","tooltip":"RectanglesChart_tooltip__Kyqmv"};